module.exports = __webpack_public_path__ + "img/jgrz.d9f108ca.png";